import { render } from "./UserCenter.vue?vue&type=template&id=525b0062&scoped=true"
import script from "./UserCenter.vue?vue&type=script&lang=js"
export * from "./UserCenter.vue?vue&type=script&lang=js"

import "./UserCenter.vue?vue&type=style&index=0&id=525b0062&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-525b0062"

export default script